<template>
  <v-col class="shrink price-col" :sm="numCols" :md="numCols"
    >${{ price.toFixed(2) }}
    <template v-if="item.unit">
      <br v-if="isSmOrLess" />
      {{ isSmOrLess ? '' : ' | ' }}
      <span class="item-unit">{{ `${item.unit}` }}</span>
    </template>
  </v-col>
</template>

<script>
import _includes from 'lodash/includes'
export default {
  name: 'MenuItemPrice',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    numCols() {
      if (this.$route.params.phone) {
        if (_includes(['ml', 'md', 'lg'], this.$mq)) {
          return 3
        }
        return 2
      } else {
        if (_includes(['xs', 'sm'], this.$mq)) {
          return 3
        } else if (_includes(['ml', 'md', 'lg', 'xl'], this.$mq)) {
          return 3
        } else {
          return null
        }
      }
    },
    isSmOrLess() {
      return _includes(['sm', 'xs'], this.$mq)
    },
  },
}
</script>

<style lang="scss" scoped>
.item-unit {
  font-style: italic;
  color: lighten(black, 30);
}
</style>
